import React from 'react';
import './StarRating.css';

const StarRating = ({ rating, onRating, disabled = false }) => {
  const handleClick = (value) => {
    if (!disabled && onRating) {
      onRating(value);
    }
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((value) => (
        <span
          key={value}
          className={`star ${value <= (rating || 0) ? 'filled' : 'empty'}`}
          onClick={() => handleClick(value)}
          style={{ cursor: disabled ? 'default' : 'pointer' }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
